import { computed, ref } from 'vue';

const ALL_PLAN_TYPE_OPTIONS: Array<{ label: string; value: string }> = [
  { label: 'Amplia', value: 'Amplia' },
  { label: 'Plus', value: 'Plus' },
  { label: 'Limitada', value: 'Limitada' },
  { label: 'RC', value: 'Responsabilidad Civil' },
];

export function usePlanSelection() {
  const selectedPaymentMethod = ref('Contado');
  const selectedPlanType = ref('Amplia');

  const planTypeOptions = computed(() => ALL_PLAN_TYPE_OPTIONS.filter((opt) => opt.value !== 'Plus'));

  const selectedPlanTypeLabel = computed(() =>
    selectedPlanType.value === 'Responsabilidad Civil' ? 'RC' : selectedPlanType.value
  );

  return { selectedPaymentMethod, selectedPlanType, planTypeOptions, selectedPlanTypeLabel };
}
